export var DynamicFormControlType = /*#__PURE__*/function (DynamicFormControlType) {
  DynamicFormControlType["primitive"] = "primitive";
  DynamicFormControlType["object"] = "object";
  DynamicFormControlType["primitiveArray"] = "primitiveArray";
  DynamicFormControlType["objectArray"] = "objectArray";
  return DynamicFormControlType;
}(DynamicFormControlType || {});